<div>
  <h2 class="sectionTitle">{{ OrgProfile?.PartnerName }} Purchases</h2>
  <div class="packages-subtext">
    <span [innerHtml]="getWlpPackageText"></span>
  </div>
  <div class="row medium">
    <div class="col-md-12">
      @if (ShowPackages) {
        <div>
      <wj-flex-grid [allowDragging]="'None'" 
        [selectionMode]="'None'" 
        [allowResizing]="'None'" 
        [headersVisibility]="'Column'"
        [itemsSource]="packageCollectionView" 
        [isReadOnly]="true" 
        width="100%" 
        [autoGenerateColumns]="false">
        <wj-flex-grid-column width=".55*" header="Packages" binding="PackageName">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(canOpenPackagesAddons && item?.PackageType !== 'BillOnly' && item?.PackageType !== "RecurringUsage"){
              <a href="javascript:void(0)" (click)="SelectPackage(item)" class="no-href-link">{{
              item.PackageName
            }}</a>
            } @else {
              {{ item.PackageName }}
            }
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Seats" binding="NumberAllowed" align="center"></wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Assigned" binding="NumberUsed" align="center"></wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Remaining" align="center">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            {{ item.NumberAllowed - item.NumberUsed }}
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
        </div>
      }
      @if (ShowAddOns) {
        <div>
                <wj-flex-grid [allowDragging]="'None'" 
        [selectionMode]="'None'" 
        [allowResizing]="'None'" 
        [headersVisibility]="'Column'"
        [itemsSource]="addOnCollectionView" 
        [isReadOnly]="true" 
        width="100%" 
        [autoGenerateColumns]="false">
        <wj-flex-grid-column width=".55*" header="Add-ons" binding="PackageName">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(canOpenPackagesAddons){
              <a href="javascript:void(0)" (click)="SelectPackage(item)" class="no-href-link">{{
              item.PackageName
            }}</a>
            } @else {
              {{ item.PackageName }}
            }
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Seats" binding="NumberAllowed" align="center"></wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Assigned" binding="NumberUsed" align="center"></wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Remaining" align="center">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            {{ item.NumberAllowed - item.NumberUsed }}
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
        </div>
      }
    </div>
  </div>
</div>
